import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppStore } from '../../../store/store';

/**
 * Non-closable overlay shown when a new app version is deployed.
 * User must click "Reload" to refresh the page and load the new chunks.
 * Same pattern as SessionExpiredOverlay; state comes from store (appEvents.appUpdated).
 */
export default function AppUpdatedOverlay() {
  const { t } = useTranslation();
  const isOpen = useAppStore((s) => s.appEvents.appUpdated.isOpen);

  const modalStyles = { mask: { backdropFilter: 'blur(5px)' } };

  return (
    <Modal
      open={isOpen}
      closable={false}
      mask={{ closable: false }}
      footer={
        <div className="flex justify-end gap-2">
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('modal.appUpdated.reloadButton')}
          </Button>
        </div>
      }
      centered
      width={400}
      zIndex={9999}
      data-testid="app-updated-modal"
      styles={modalStyles}
      className="bg-black/25! backdrop-blur-sm!"
    >
      <h2 className="text-blue-dark mb-2 text-lg font-semibold">{t('modal.appUpdated.title')}</h2>
      <p className="text-blue-dark text-sm">{t('modal.appUpdated.description')}</p>
    </Modal>
  );
}
